import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLargeRight"><Path fillRule="evenodd" clipRule="evenodd" d="M10.3885 1.64062L16.1439 12.0004L10.3885 22.3602L8.64014 21.3889L13.856 12.0004L8.64014 2.61191L10.3885 1.64062Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeRight;
